import React from 'react';
import { Loader } from './Loader';
import styles from './SuspenseLoader.module.css';

export const SuspenseLoader: React.FC = () => {
  return (
    <div className={styles.suspenseWrapper}>
      <div className={styles.backgroundImage} />
      <div className={styles.overlay} />
      <Loader fullscreen={false} size="large" />
    </div>
  );
};